import { Fragment } from "react";

const ViewAssessmentExamQuestion = ({ index, input }) => {
  if (!input) return null;

  return (
    <Fragment>
      <hr className="my-5" />

      <div className="px-4">
        <label className="block font-medium text-sky-700 dark:text-sky-300">
          {index + 1}. {input.question}
        </label>
      </div>

      <hr className="my-5" />

      {input.options.map((m, i) => (
        <div
          key={i}
          className={`
            flex items-center px-4 py-2 rounded-md mb-2
            ${m.isAnswer && input.answer !== m.id ? "text-green-600" : ""}
            ${m.isAnswer && input.answer === m.id ? "text-green-700 font-semibold" : ""}
            ${!m.isAnswer && input.answer === m.id ? "text-red-600" : ""}
          `}
        >
          <input
            type="checkbox"
            disabled
            checked={input.answer === m.id}
            className="w-5 h-5 accent-blue-500 dark:accent-blue-400"
          />

          <span className="ml-3">{m.option}</span>

          <span className="ml-auto text-base">
            {m.isAnswer && input.answer !== m.id && "Correct Answer"}
            {m.isAnswer && input.answer === m.id && "Right Answer"}
            {!m.isAnswer && input.answer === m.id && "Your Answer"}
          </span>
        </div>
      ))}
            <div className="flex justify-end items-center mt-4 px-4">
        <input type="checkbox" className="w-5 h-5" disabled checked={input.isConfident} />
        <span className="ml-2">Confident?</span>
      </div>


      <hr className="my-5" />
    </Fragment>
  );
};

export default ViewAssessmentExamQuestion;
